<template>

    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ restaurant.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <RestaurantsTabLinks />
                    <CRow class="pl-3 pb-3" />
                    
                    <CRow class="pb-3">
                        <CCol
                            v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly)"  
                            sm="12">
                            <CButton color="primary" @click="create">Создать</CButton>
                        </CCol>
                    </CRow>                    
                    <CRow class="pl-3">
                        <table class="table">
                            <thead>
                                <th></th>
                                <th>Название</th>
                                <th>Стоимость</th>
                                <th class="desktop-only">Активен</th>
                                <th></th>
                            </thead>
                            <draggable v-model="modifiers" tag="tbody">
                                <tr v-for="modifier in modifiers" :key="modifier.title">
                                    <td><CIcon
                                        :height="24"
                                        :content="$options.icons.cilCursorMove"
                                        class="handle" /></td>
                                    <td>{{ modifier.title }}</td>
                                    <td>{{ modifier.price }}</td>

                                    <td class="desktop-only">
                                        <CBadge :color="getBadge(modifier.enabled)">
                                            &nbsp;{{ modifier.enabled ? 'Да' : 'Нет' }}&nbsp;
                                        </CBadge>
                                    </td>
                                    <td>
                                        <CButton @click="edit(modifier.id)"><CIcon :content="$options.icons.cilPencil" class="handle" /></CButton>
                                        <CButton
                                            v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly)"  
                                            @click="removeConfirmation(modifier.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            :title="createEditModalTitle"
            :show.sync="createEditModal.visible"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Название</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.modifier.title"
                                    placeholder="Название модификатора"
                                    description="Обязательно для заполнения"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Стоимость</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.modifier.price"
                                    placeholder="Стоимость модификатора"
                                    description="Введите 0, если не влияет на стоимость блюда"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Вес</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.modifier.weight"
                                    placeholder="Вес"
                                    description="Введите 0, если не влияет на вес"
                                />
                            </CCol>

                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Калории</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.modifier.calories"
                                    placeholder="Калории"
                                    description="Введите 0, если не влияет на калории"
                                />
                            </CCol>

                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Белки</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.modifier.protein"
                                    placeholder="Белок"
                                    description="Введите 0, если не влияет на белок"
                                    step="0.1"
                                />
                            </CCol>

                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Жиры</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.modifier.fat"
                                    placeholder="Жиры"
                                    description="Введите 0, если не влияет на жиры"
                                    step="0.1"
                                />
                            </CCol>

                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Углеводы</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.modifier.carbohydrates"
                                    placeholder="Углеводы"
                                    description="Введите 0, если не влияет на углеводы"
                                    step="0.1"
                                />
                            </CCol>

                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Активен</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="createEditModal.modifier.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="createEditModal.visible = false">Отмена</CButton>
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="createUpdateModifier">{{ createEditModalButton }}</CButton>
                </div>
            </template>
        </CModal>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal.visible"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>Вы действительно хотите удалить модификатор? Это действие нельзя будет отменить.</p>
                </div>
                <div
                    v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly)"  
                    slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal.visible = false">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="remove">Удалить</CButton>
                </div>
            </template>
        </CModal>


    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash, cilPencil } from '@coreui/icons';
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';

    export default {

        name: 'RestaurantModifiers',

        components: {
            RestaurantsTabLinks,
            draggable,
        },
  
        data () {
            return {
                restaurant: {},
                modifiers: [],
                createEditModal: {
                    visible: false,
                    editMode: false,
                    editId:0,
                    modifier: {
                        title: '',
                        price: 0,
                        enabled: false,
                        position: 0,
                        weight: 0,

                        carbohydrates: 0,
                        protein: 0,
                        fat: 0,
                        calories: 0,
                    }
                },
                deleteModal: {
                    visible: false,
                    modifierId: 0
                }
            }
        },
    
        computed: {
            createEditModalTitle: function() {
                return this.createEditModal.editMode ? 'Редактирование модификатора' : 'Создание модификатора';
            },
            createEditModalButton: function() {
                return this.createEditModal.editMode ? 'Сохранить' : 'Создать';
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
        },

        mounted() {
            const id = this.$route.params.id;
            Vue.axios.get('/restaurants/' + id)
                .then(resp => {
                    this.restaurant = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get('/restaurants/' + id + '/modifiers')
                .then(resp => {
                    this.modifiers = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        icons: {
            cilCursorMove,
            cilTrash,
            cilPencil
        },

        methods: {
            formatMacro(value) {
                const n = Number(value);
                if (!Number.isFinite(n)) return '0.0';
                return (Math.round((n + Number.EPSILON) * 10) / 10).toFixed(1);
            },

            create() {
                this.createEditModal.editMode = false;
                this.createEditModal.modifier.title = '',
                this.createEditModal.modifier.price = 0;
                this.createEditModal.modifier.weight = 0;
                this.createEditModal.modifier.carbohydrates = this.formatMacro(0);
                this.createEditModal.modifier.fat = this.formatMacro(0);
                this.createEditModal.modifier.protein = this.formatMacro(0);
                this.createEditModal.modifier.calories = 0;
                this.createEditModal.modifier.enabled = true;
                this.createEditModal.visible = true;
            },

            createUpdateModifier() {
            
                if(!this.createEditModal.modifier.title) {
                    this.$root.$emit('showError', 'Название модификатора является обязательным.');
                    return;
                }
                if(this.createEditModal.modifier.price === null) {
                    this.$root.$emit('showError', 'Стоимость является обязательной для заполнения.');
                    return;
                }

                if(this.createEditModal.editMode) {
                    Vue.axios.post('/restaurants/' + this.restaurant.id + '/modifiers/update/' + this.createEditModal.editId , this.createEditModal.modifier)
                        .then(resp => {
                            const justUpdated = resp.data;
                            const _modifiers = this.modifiers.slice();
                            for(var i = 0; i < _modifiers.length; i++) {
                                if(_modifiers[i].id === justUpdated.id) {
                                    _modifiers[i] = justUpdated;
                                }
                            }
                            this.modifiers = _modifiers;
                            this.createEditModal.visible = false;
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка сохранения.');
                        });
                } else {
                    Vue.axios.post('/restaurants/' + this.restaurant.id + '/modifiers/create', this.createEditModal.modifier)
                        .then(resp => {
                            const justCreated = resp.data;
                            const _modifiers = this.modifiers.slice();
                            _modifiers.push(justCreated);
                            this.modifiers = _modifiers;
                            this.createEditModal.visible = false;
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка сохранения.');
                        });
                }
            },

            edit(id) {
                this.createEditModal.editId = id;
                this.createEditModal.editMode = true;
            
                var _modifier = {};
                for(var i = 0; i < this.modifiers.length; i++) {
                    if(this.modifiers[i].id === id) {
                        _modifier = this.modifiers[i];
                    }
                }

                this.createEditModal.modifier.title = _modifier.title,
                this.createEditModal.modifier.price = _modifier.price;

                this.createEditModal.modifier.weight = +_modifier.weight;
                this.createEditModal.modifier.calories = +_modifier.calories;
                this.createEditModal.modifier.protein = this.formatMacro(_modifier.protein);
                this.createEditModal.modifier.fat = this.formatMacro(_modifier.fat);
                this.createEditModal.modifier.carbohydrates = this.formatMacro(_modifier.carbohydrates);

                this.createEditModal.modifier.enabled = _modifier.enabled;
                this.createEditModal.modifier.position = _modifier.position;
            
                this.createEditModal.visible = true;
            },

            save() {
                // Save order only
                const reorder = [];
                let index = 0;
                this.modifiers.forEach(modifier => {
                    reorder.push({
                        id: modifier.id,
                        position: ++index
                    });
                });
                Vue.axios.post('/restaurants/' + this.restaurant.id + '/modifiers/reorder', { reorder: reorder })
                    .then(resp => {
                        this.$router.push('/restaurants/' + this.restaurant.id)
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            removeConfirmation(id) {
                this.deleteModal.modifierId = id;
                this.deleteModal.visible = true;
            },

            remove() {
                const id = this.deleteModal.modifierId;
                Vue.axios.delete('/restaurants/' + this.restaurant.id + '/modifiers/' + id)
                    .then(resp => {
                        const _modifiers = [];
                        for(var i = 0; i < this.modifiers.length; i++) {
                            if(id != this.modifiers[i].id) {
                                _modifiers.push(this.modifiers[i]);
                            }
                        }
                        this.modifiers = _modifiers;
                        this.deleteModal.visible = false;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            goBack() {
                this.$router.push({ path: '/restaurants/' + this.$route.params.id })
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
        }
    }

</script>
<style scoped>
.handle {
  cursor: pointer;
}
@media (max-width: 767px) {
    .desktop-only {
        display: none;
    }
}
</style>